import React, { Component } from 'react'
import logo from '../images/ipark-logo.png'
import '../styles/loadingPage.css'

export default class LoadingPage extends Component {
    render() {
        return (
            <div>
                <div className="container loading-container">

                    <div className="text-center loading-image"><img src={logo} alt="" /></div>
                    <div className="col-lg-12 text-center">
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
